import ko from 'knockout';
import PerfectScrollbar from 'perfect-scrollbar';

ko.bindingHandlers['scrollbar'] = {
    init: function (element) {

        const ps = new PerfectScrollbar(element, {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => ps.destroy());
    }
};